import { VideoProject } from './gallery';

// Media Configuration and Structure
interface MediaConfig {
  paths: {
    videos: string;
    thumbnails: string;
    backgrounds: string;
    headers: string;
    images: string;
    icons: string;
  };
  hero: {
    video: {
      url: string;
      poster: string;
      alt: string;
      title: string;
      subtitle: string;
    };
  };
  showreel: {
    video: {
      url: string;
      poster: string;
      alt: string;
      title: string;
    };
  };
  gallery: {
    videos: VideoProject[];
  };
}

export const MEDIA_CONFIG: MediaConfig = {
  paths: {
    videos: '/media/videos',
    thumbnails: '/media/thumbnails',
    backgrounds: '/media/backgrounds',
    headers: '/media/backgrounds/headers',
    images: '/media/images',
    icons: '/media/icons'
  },
  hero: {
    video: {
      url: '/media/videos/header.mp4',
      poster: '/media/thumbnails/header-poster.jpg',
      alt: 'honzamedia Hero Video',
      title: "Visuelle Geschichten, die bewegen",
      subtitle: "Professionelle Film- und Videoproduktion\nmit persönlicher Note"
    }
  },
  showreel: {
    video: {
      url: '/media/videos/showreel.mp4',
      poster: '/media/thumbnails/showreel-poster.jpg',
      alt: 'honzamedia Showreel 2024',
      title: 'SHOWREEL 2024'
    }
  },
  gallery: {
    videos: [
      {
        id: 1,
        title: "Kapelle Ahaus",
        description: "Ein atmosphärisches Porträt der Kapelle Ahaus, das die Architektur und das besondere Design eindrucksvoll einfängt.",
        videoUrl: "/media/videos/gallery/video1.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_1.jpg",
        credits: {
          production: "Philip Kistner",
          director: "Philip Kistner",
          cinematographer: "Philip Kistner, Cynthia Ruf, Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek, Philip Kistner"
        }
      },
      {
        id: 2,
        title: "Edeka Bungert",
        description: "Ein Werbevideo, das die speziell bei Edeka Bungert eingesetzten Theken und Regale in den Fokus rückt.",
        videoUrl: "/media/videos/gallery/video2.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_2.jpg",
        credits: {
          production: "Philip Kistner",
          director: "Philip Kistner",
          cinematographer: "Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 3,
        title: "Nicht Ohne Dich",
        description: "Eine Werbekampagne für den KinderJugendRat in Bielefeld, die junge Menschen motivieren und inspirieren soll.",
        videoUrl: "/media/videos/gallery/video3.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_3.jpg",
        credits: {
          production: "kopterwork",
          director: "Daniel Manns, kopterwork",
          cinematographer: "kopterwork",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 4,
        title: "Empty Bielefeld",
        description: "Ein filmisches Zeitdokument über das menschenleere Bielefeld während der Corona-Pandemie.",
        videoUrl: "/media/videos/gallery/video4.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_4.jpg",
        credits: {
          production: "kopterwork",
          director: "kopterwork",
          cinematographer: "Andreas Olenberg, Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 5,
        title: "AVU",
        description: "Ein modernes Unternehmensvideo über ein Windrad der AVU, das erneuerbare Energie und Nachhaltigkeit in Szene setzt.",
        videoUrl: "/media/videos/gallery/video5.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_5.jpg",
        credits: {
          production: "Philip Kistner",
          director: "Philip Kistner",
          cinematographer: "Philip Kistner, kopterwork",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 6,
        title: "HWK (Handwerkskammer Bielefeld)",
        description: "Eine Dokumentation der besonderen Zeugnisübergabe zur Corona-Zeit, die als Autokino-Veranstaltung stattfand.",
        videoUrl: "/media/videos/gallery/video6.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_6.jpg",
        credits: {
          production: "kopterwork",
          director: "Daniel Manns",
          cinematographer: "Björn Leisten, Malte Blum, Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 7,
        title: "Melitta 8er",
        description: "Ein Film über die von Melitta gesponserte Ruder-Mannschaft, der ihren Trainingsalltag und die sportlichen Herausforderungen zeigt.",
        videoUrl: "/media/videos/gallery/video7.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_7.jpg",
        credits: {
          production: "kopterwork, Die Filmpiraten",
          director: "Daniel Manns",
          cinematographer: "Andreas Olenberg, Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 8,
        title: "DMS",
        description: "Ein Werbefilm für Druck Media Service aus Porta Westfalica, der moderne Drucklösungen und Medienservices präsentiert.",
        videoUrl: "/media/videos/gallery/video8.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_8.jpg",
        credits: {
          production: "Die Filmpiraten",
          director: "Andreas Olenberg, Manuel Mohnke",
          cinematographer: "Andreas Olenberg, Jan Ctvrtnicek",
          editor: "Andreas Olenberg"
        }
      },
      {
        id: 9,
        title: "Dualität",
        description: "Ein experimenteller Film, der das Spannungsverhältnis zwischen Kunst und Design erforscht.",
        videoUrl: "/media/videos/gallery/video9.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_9.jpg",
        credits: {
          production: "Kamil E.",
          director: "Kamil E.",
          cinematographer: "Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 10,
        title: "Hochzeit Jade & Noel",
        description: "Ein romantischer Hochzeitsfilm, der die besonderen Momente dieses Tages einfängt.",
        videoUrl: "/media/videos/gallery/video10.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_10.jpg",
        credits: {
          production: "HonzaMedia",
          director: "Jan Ctvrtnicek",
          cinematographer: "Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek"
        }
      },
      {
        id: 11,
        title: "Hochzeit Lara & Dennis",
        description: "Eine emotionale Hochzeitsdokumentation, die die Liebe und die Atmosphäre des Tages einfängt.",
        videoUrl: "/media/videos/gallery/video11.mp4",
        thumbnailUrl: "/media/thumbnails/gallery/video_11.jpg",
        credits: {
          production: "HonzaMedia",
          director: "Jan Ctvrtnicek",
          cinematographer: "Jan Ctvrtnicek",
          editor: "Jan Ctvrtnicek"
        }
      }
    ]
  }
};